export default "__VITE_ASSET__HHmXL23U__"